import React from "react";
import Tooltip from "./tooltip";

const Switch = ({ label, keyName, options, value, onChange, tooltip = null, as = "li" }) => {
  const Element = as;
  const isList = as === "li";

  const formatted = Array.isArray(options)
    ? options
    : Object.entries(options).map(([key, label]) => ({
        value: key === "true" ? true : key === "false" ? false : key,
        label,
      }));

  const renderOptions = () => (
    <div className="cont switches">
      {formatted.map(({ value: optionValue, label }) => (
        <span
          key={String(optionValue)}
          onClick={() => onChange(optionValue)}
          className={value === optionValue ? "active" : "inactive"}>
          {label}
        </span>
      ))}
    </div>
  );

  return (
    <Element className={`${keyName} ${isList ? "" : "switch-block"}`}>
      {isList &&
        (tooltip ? (
          <Tooltip label={label} tooltip={tooltip} />
        ) : (
          <span className="tit">{label}</span>
        ))}
      {renderOptions()}
    </Element>
  );
};

export default Switch;
